<template>
  <div class="p-md-3 w-100">
    <div class="row pb-3 pt-0">
      <div class="col-md-12 d-flex justify-content-start align-items-center">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb p-0 m-0">
            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
            <li class="breadcrumb-item" aria-current="page"> Account Details</li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <form @submit.prevent="resetPassword">
          <div class="card">
            <div class="d-flex card-header justify-content-start align-items-center">
              <h4 class="header-title">Reset Password</h4>
            </div>
            <div class="card-body">
              <div class="mb-2">
                <label for="current-password" class="form-label">Current Password</label>
                <input id="current-password" type="password" class="form-control" v-model="currentPassword" required>
              </div>
              <div class="mb-2">
                <label for="new-password" class="form-label">New Password</label>
                <input id="new-password" type="password" class="form-control" v-model="newPassword" minlength="8" required>
              </div>
              <div class="mb-2">
                <label for="confirm-password" class="form-label">Confirm Password</label>
                <input id="confirm-password" type="password" class="form-control" v-model="confirmPassword" minlength="8" required>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <button type="submit" class="btn btn-primary float-end text-dark mt-2 w-100">
                    <i class="fa-duotone fa-solid fa-circle-check me-1"></i> Save Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
    
<script lang="js">
import { defineComponent } from 'vue'
import Mixin from '../mixins/global.mixin'
import axios from 'axios';
import appConstants from '@/constants/app.constants';
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
  
export default defineComponent({
  name: 'PasswordReset',
  mixins: [Mixin],
  computed: mapState([
      'isCollapse',
      'currentUserSession',
      'currentSessionEmail',
      'p2b7cc318da9ba9d03912592c2f34a1ec',
      'jwtToken'
  ]),
  data() {
    return {
      newPassword: null,
      confirmPassword: null,
      currentPassword: null,
      isSubmitDisabled: false
    }
  },
  methods: {
    resetPassword: function () {
      switch (true) {
        case (this.currentPassword != this.p2b7cc318da9ba9d03912592c2f34a1ec):
          Swal.fire({
            icon: "error",
            text: "Please recheck your current password",
            customClass: {
              confirmButton: 'btn-primary'
            }
          });
          break;
        case (this.newPassword == this.currentPassword):
          Swal.fire({
            icon: "error",
            text: "Please provide a new password",
            customClass: {
              confirmButton: 'btn-primary'
            }
          });
          break;
        case (this.confirmPassword != this.newPassword):
          Swal.fire({
            icon: "error",
            text: "Passwords did not match",
            customClass: {
              confirmButton: 'btn-primary'
            }
          });
          break;
        default:
          this.toggleFullScreenSpinner(true);
          axios({
            method: 'put',
            headers : { 'Content-Type' : "application/json"},
            data: {
                "JWT": this.jwtToken,
                "AUTH_KEY": appConstants.AUTH_KEY,
                "email": this.currentSessionEmail,
                "new_password": this.newPassword
            },
            url: appConstants.SITEURL+'/wp-json/simple-jwt-login/v1/user/reset_password',
          }).then((response) => {
            console.log(response.data);
            this.toggleFullScreenSpinner(false);
            Swal.fire({
              icon: "success",
              text: "Password has been changed. Logging you out!",
              customClass: {
                confirmButton: 'btn-primary'
              }
            });
            setTimeout(() => {
              this.forceLogout(true);
            }, 1000);
          }).catch(() => {
            Swal.fire({
              icon: "error",
              text: "There was an error updating your password",
              customClass: {
                confirmButton: 'btn-primary'
              }
            });
          });
          break;
      }
    }
  },
  mounted() {
    setTimeout( () => {
      this.toggleFullScreenSpinner(false);
    }, 500);
  }
});
</script>
    